// extracted by mini-css-extract-plugin
export default {"vFeed":"index_vFeed_fy1Wa","vComment":"index_vComment_szAUq","vDingCai":"index_vDingCai_Hx5TO","vDing":"index_vDing_EqjHe","candle":"index_candle_VWRIT","pray":"index_pray_eJCFW"};